import React from 'react';
import PropTypes from 'prop-types';

export default function ResultCount({ currentPage, pageSize, totalItems }) {
  const showingResultsFrom = currentPage ? (currentPage - 1) * pageSize + 1 : 1;
  // eslint-disable-next-line operator-linebreak
  const showingResultsTo =
    currentPage * pageSize > totalItems ? totalItems : currentPage * pageSize;
  const renderedCount = totalItems
    ? `${showingResultsFrom} - ${showingResultsTo}  of ${totalItems} matches`
    : '0 matches';

  return <p className="result-count">{renderedCount}</p>;
}

ResultCount.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
};
